import createReactComponent from '../createReactComponent';
export default createReactComponent('chart-pie-4', 'IconChartPie4', [
  ['path', { d: 'M12 12l-6.5 5.5', key: 'svg-0' }],
  ['path', { d: 'M12 3v9h9', key: 'svg-1' }],
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-2' }],
  ['path', { d: 'M12 12l5 7.5', key: 'svg-3' }],
]);
